export default {
  questions (state) {
    return state.questions
  },
  listLoading (state) {
    return state.listLoading ? 1 : 0
  },
}
